import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import { LoaderSpinner } from 'carbon-react/lib/components/loader-spinner';
import Box from 'carbon-react/lib/components/box';

import { FormattedMessage } from '@futrli/localisation';

import { ToastMessage } from '../messages';

export enum LOADER_AREAS {
  appArea = 'app-area',
  predictArea = 'predict-area'
}

type UIPromiseTrackerLoaderClassKey = 'root' | 'message';

interface UIPromiseTrackerLoaderOwnProps {
  /**
   * Scope whre the laoder is going to work over.
   * @default 'app-area'
   */
  area?: LOADER_AREAS;
  /**
   *
   */
  classes?: Partial<Record<UIPromiseTrackerLoaderClassKey, string>>;
  /**
   * Message to be displayed.
   */
  message?: React.ReactNode;
}

type UIPromiseTrackerLoaderProps = UIPromiseTrackerLoaderOwnProps;

/**
 * A Promise tracker Loader component.
 */
export const UIPromiseTrackerLoader: React.FC<UIPromiseTrackerLoaderProps> = props => {
  const { area = LOADER_AREAS.appArea, message } = props;

  const { promiseInProgress } = usePromiseTracker({ area });

  const messageArea =
    area === LOADER_AREAS.predictArea ? (
      <FormattedMessage defaultMessage="Updating your numbers" id="common.updating_your_numbers" />
    ) : (
      <FormattedMessage defaultMessage="Loading..." id="common.loading" />
    );

  return (
    <ToastMessage open={promiseInProgress} variant="neutral">
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <LoaderSpinner showSpinnerLabel={false} size="extra-small" mr="8px" />
        {message || messageArea}
      </Box>
    </ToastMessage>
  );
};
